import React, { FC, PropsWithChildren } from 'react'

import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { WithStyle } from 'common/types'
import { breakpoints } from 'components/designSystem/shared/breakpoints'
import { Typography } from 'components/designSystem/Typography/Typography'

import appStoreButton from './app_store.svg'
import googlePlayButton from './google_play.svg'
import googlePlayStars from './stars_4.3.svg'
import appStoreStars from './stars_4.5.svg'
import users from './users.png'
import users2x from './users_2x.png'
import { appStoreLink, googlePlayLink } from '../WaveBoarding.constants'

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 80px;
  text-align: center;
`

const Text = styled.div`
  max-width: 60%;
  margin-top: 20px;
  margin-bottom: 48px;

  @media (max-width: ${breakpoints.mobile - 1}px) {
    max-width: 90%;
  }
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 5px;
  grid-column-gap: 2%;
  max-width: 80%;
  place-items: center center;
  grid-template-areas:
    'score-as score-gp data'
    'stars-as stars-gp subheader'
    'button-as button-gp users';

  @media (max-width: ${breakpoints.mobile - 1}px) {
    grid-template-columns: auto;
    grid-template-areas:
      'score-as score-gp'
      'stars-as stars-gp'
      'button-as button-gp'
      'data data'
      'subheader subheader'
      '. .'
      'users users';
    grid-column-gap: 14px;
  }
`

const Header: FC<WithStyle & PropsWithChildren> = ({ style, children }) => {
  return (
    <Typography
      fontSize={40}
      fontWeight={700}
      style={{ textAlign: 'center', ...style }}
      tag="h2"
    >
      {children}
    </Typography>
  )
}

const DataHeader = styled(Header)`
  @media (max-width: ${breakpoints.mobile - 1}px) {
    grid-row: span 2;
  }
`

const StoreButton = styled.img`
  @media (max-width: ${breakpoints.mobile - 1}px) {
    width: 35vw;
  }
`

const Stars = styled.img`
  @media (max-width: ${breakpoints.mobile - 1}px) {
    width: 40vw;
  }
`

const UsersImage = styled.img`
  width: 20vw;

  @media (max-width: ${breakpoints.mobile - 1}px) {
    width: 197px;
    grid-row: span 2;
  }
`

const Subheader = styled.div`
  align-self: start;
  text-align: center;

  @media (max-width: ${breakpoints.mobile - 1}px) {
    grid-row: span 2;
  }
`

export const DownloadApp: FC = () => {
  return (
    <Container>
      <Typography fontSize={40} fontWeight={700} tag="h2">
        <FormattedMessage
          id="download_app.title"
          defaultMessage="Скачай приложение Мамбы"
        />
      </Typography>
      <Text>
        <Typography fontSize={20} fontWeight={400}>
          <FormattedMessage
            id="download_app.text_1"
            defaultMessage="Мамба — это один из самых больших дейтингов в РФ и СНГ, каждый день у нас более 500 тыс. мэтчей и более 1 млн. взаимных переписок. Здесь легко найти людей с общими целями и интересами, мы уже позаботились об удобном поиске, умных алгоритмах, разнообразных фильтрах, и, конечно, безопасности. Тебе остаётся только выбрать, кого ты хочешь найти сегодня, и новые знакомства тебе гарантированы."
          />
        </Typography>
      </Text>

      <Grid>
        <Header style={{ gridArea: 'score-as' }}>4,5</Header>
        <Header style={{ gridArea: 'score-gp' }}>4,3</Header>
        <DataHeader style={{ gridArea: 'data' }}>
          <FormattedMessage
            id="download_app.quantity"
            values={{ more: '>' }}
            defaultMessage="{more} 70 млн"
          />
        </DataHeader>

        <Stars
          src={appStoreStars}
          style={{ gridArea: 'stars-as' }}
          alt="App Store Stars"
          loading="lazy"
        />

        <Stars
          src={googlePlayStars}
          style={{ gridArea: 'stars-gp' }}
          alt="Google Play Stars"
          loading="lazy"
        />

        <Subheader
          style={{
            gridArea: 'subheader',
          }}
        >
          <Typography fontSize={16} fontWeight={400}>
            <FormattedMessage
              id="download_app.users"
              defaultMessage="пользователей"
            />
          </Typography>
        </Subheader>

        <a href={appStoreLink} data-name="download-app-store-action">
          <StoreButton
            src={appStoreButton}
            alt="App Store Block"
            loading="lazy"
            style={{ gridArea: 'button-as' }}
          />
        </a>
        <a href={googlePlayLink} data-name="download-google-play-action">
          <StoreButton
            src={googlePlayButton}
            alt="Google Play Block"
            loading="lazy"
            style={{ gridArea: 'button-gp' }}
          />
        </a>

        <UsersImage
          src={users}
          srcSet={`${users2x} 2x`}
          alt="Users"
          style={{ gridArea: 'users' }}
          loading="lazy"
        />
      </Grid>
    </Container>
  )
}
